import React, { useEffect, useState } from 'react';
import "./style.sass";
import { useHistory } from 'react-router-dom';
import { removeStorage } from 'functions/storageBase64';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { InformacionEmpleoMobile } from './informacionEmpleoMobile';
import { InformacionPersonalMobile } from './informacionPersonalMobile';
import { InformacionFinancieraMobile } from './informacionFinancieraMobile';
import { SolicitudFinalizadaMobile } from './solicitudFinalizadaMobile';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { Error500 } from 'components/Error/Error500'

export function SolicitarTarjetaMobile() {

    const history = useHistory();
    const [pasoSolicitudMobile, setPasoSolicitudMobile] = useState(1);
    const [numFolio , setNumFolio] = useState(false);

    // establece el paso actual
    const fijarPasoActual = (paso) => {
        setPasoSolicitudMobile(paso);
    }

    // regresa a la pagina principal de credito
    const cancelar = () => {
        //history.replace(`${BASE_PATH}${SUB_DIRECTORY}home`);
        if (pasoSolicitudMobile === 1) {
            history.goBack(-1);
        }
        else {
            setPasoSolicitudMobile(1);
        }
    }

    const [errorCode, setErrorCode] = useState()

    // borra datos del storage al recargar 
    useEffect(() => {
        removeStorage('infoPersonalMobileStorage');
        removeStorage('infoTrabajoMobileStorage');
        removeStorage('infoFinancieraMobileStorage');
    }, [])

    return (
        errorCode >= 500
            ? 
                <div className="modalCredito full">
                    <div className="contentModal">
                        <HeaderMobileCredito title="Solicitud de Crédito Claroshop" type="back" />
                        <Error500 />
                    </div>
                </div>
            :
                <>
                    
                    {pasoSolicitudMobile === 1 && <InformacionPersonalMobile nextPage={fijarPasoActual} cancelar={cancelar} />}

                    {pasoSolicitudMobile === 2 && <InformacionEmpleoMobile nextPage={fijarPasoActual} cancelar={cancelar} />}

                    {pasoSolicitudMobile === 3 && <InformacionFinancieraMobile nextPage={fijarPasoActual} cancelar={cancelar} setNumFolio={setNumFolio} setErrorC={setErrorCode}/>}

                    {pasoSolicitudMobile === 4 && <SolicitudFinalizadaMobile cancelar={cancelar} numFolio={numFolio}/>}

                </>
            
    )
}